import React, { useState } from 'react';
import '../../styles/loginPage.css';
import '../../styles/register.css';
import { notify } from '../toast';
import useAxiosPrivate from '../../api/useAxiosPrivate';
import Modal from 'react-modal';
import imageCompression from 'browser-image-compression';

const HolderRegister = () => {
    const [name, setName] = useState('');
    const [gender, setGender] = useState('');
    const [mobile, setMobile] = useState('');
    const [age, setAge] = useState('');
    const [occupation, setOccupation] = useState('');
    const [address, setAddress] = useState('');
    const [village, setVillage] = useState('');
    const [mandal, setMandal] = useState('');
    const [district, setDistrict] = useState('');
    const [pincode, setPincode] = useState('');
    const [aadhaar, setAadhaar] = useState('');
    const [member1, setMember1] = useState({ name: '', gender: '', age: '', mobile: '' });
    const [member2, setMember2] = useState({ name: '', gender: '', age: '', mobile: '' });
    const [member3, setMember3] = useState({ name: '', gender: '', age: '', mobile: '' });
    const [member4, setMember4] = useState({ name: '', gender: '', age: '', mobile: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const [holderId, setHolderId] = useState('');
    const [openPhotoUpload, setOpenPhotoUpload] = useState(false);


    const axiosPrivate = useAxiosPrivate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');

        if (!validateMobile(mobile) || mobile.length !== 10) {
            return setError('Invalid mobile number');
        } else {

            const members = [member1, member2, member3, member4].filter(
                member => member.name && member.name.trim() !== "");

            for (const member of members) {
                if (!validateMobile(member.mobile) || member.mobile.length !== 10) {
                    notify('failed', `Invalid member ${member.name} mobile number`);
                    return;
                }
            }

            try {
                setLoading(true);

                await axiosPrivate.get('/getConflictHolder?holderMobile=' + mobile);

                const orderRes = await axiosPrivate.post('/createOrder', {
                    name,
                    gender,
                    mobile,
                    age,
                    address,
                    occupation,
                    village,
                    district,
                    pincode,
                    mandal,
                    aadhaar,
                    members,
                });
                const order = orderRes?.data;

                var options = {
                    "key": "rzp_live_SAoZKg9VcvXHUR",
                    "amount": order.amount,
                    "currency": "INR",
                    "name": "Ayush Care Services",
                    "description": "Registration payment",
                    "image": "https://www.ayushcareservices.com/Ayushcare.png",
                    "order_id": order.id,
                    "handler": async function (response) {
                        try {
                            const registrationResponse = await axiosPrivate.post('/holderRegister', response);
                            const res = registrationResponse?.data;
                            setHolderId(res?.holderId);
                            notify('success', res?.success);

                            setOpenPhotoUpload(true);
                        } catch (err) {
                            const errorMessage = err?.response?.data?.message || err?.message || 'error fetching server information';
                            notify('failed', errorMessage);
                        }
                    },
                    "prefill": {
                        "name": name,
                        "contact": mobile
                    },
                    "notes": {
                        "address": "Razorpay Corporate Office"
                    },
                    "theme": {
                        "color": "#3399cc"
                    }
                };
                // @ts-ignore
                var rzp1 = new window.Razorpay(options);
                rzp1.on('payment.failed', function (response) {
                    alert(response.error.code);
                    alert(response.error.description);
                    alert(response.error.source);
                    alert(response.error.step);
                    alert(response.error.reason);
                    alert(response.error.metadata.order_id);
                    alert(response.error.metadata.payment_id);
                });
                rzp1.open();

            } catch (err) {
                const errorMessage = err?.response?.data?.message || err?.message || 'error fetching server information';
                notify('failed', errorMessage);
            }
            finally {
                setLoading(false);
                setName('');
                setGender('');
                setMobile('');
                setAge('');
                setOccupation('');
                setAddress('');
                setVillage('');
                setMandal('');
                setDistrict('');
                setPincode('');
                setAadhaar('');
                setMember1({ name: '', gender: '', age: '', mobile: '' });
                setMember2({ name: '', gender: '', age: '', mobile: '' });
                setMember3({ name: '', gender: '', age: '', mobile: '' });
                setMember4({ name: '', gender: '', age: '', mobile: '' });
            }
        }
    };

    const handlePhoto = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);

            const photo = document.getElementById("photo");
            const fd = new FormData();

            // @ts-ignore
            if (!photo?.files[0]) {
                notify('info', 'Please select image before uploading')
                return
            }

            // @ts-ignore
            const compressedImage = await compressImage(photo?.files[0])
            fd.append('photo', compressedImage);

            const response = await axiosPrivate.post(`/employee/uploadHolderPhoto/${holderId}`, fd,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });

            const success = response?.data?.success;
            if (success)
                notify('success', success);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        } finally {
            setLoading(false);
            setOpenPhotoUpload(false);
        }
    }

    const compressImage = async (file) => {
        const options = {
            maxSizeMB: 0.048,
            maxWidthOrHeight: 600,
            useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);
        return compressedFile;
    };

    const validateMobile = (mobile) => {
        const re = /^[0-9]{10}$/;
        return re.test(mobile);
    };

    return (
        <>
            <div className='formContainer'>
                <div className='formWrapper'>
                    <h2 className='formTitle'>Holder Registration Form</h2>
                    {error && <div style={{ color: 'red', marginBottom: '15px', textAlign: 'center' }}>{error}</div>}
                    <form onSubmit={handleSubmit}>

                        <div className='formRow'>
                            <div className='formGroup'>
                                <div className='formGroup'>
                                    <span className='formLabel'>Name</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        autoFocus
                                        value={name}
                                        onChange={(event) => setName(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Mobile</span>
                                    <input
                                        className='formInput'
                                        type="tel"
                                        value={mobile}
                                        onChange={(event) => setMobile(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Gender</span>
                                    <select
                                        className="formInput"
                                        name='gender'
                                        value={gender}
                                        onChange={(event) => setGender(event.target.value)}
                                        required
                                    >
                                        <option value="">select</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Age</span>
                                    <input
                                        className='formInput'
                                        type="number"
                                        value={age}
                                        onChange={(event) => setAge(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Occupation</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={occupation}
                                        onChange={(event) => setOccupation(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Address</span>
                                    <input
                                        className='formInput'
                                        value={address}
                                        type="text"
                                        onChange={(event) => setAddress(event.target.value)}
                                        required
                                    />
                                </div>
                            </div>

                            <div className='formGroup'>
                                <div className='formGroup'>
                                    <span className='formLabel'>Pincode</span>
                                    <input
                                        className='formInput'
                                        type="number"
                                        value={pincode}
                                        onChange={(event) => setPincode(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Village</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={village}
                                        onChange={(event) => setVillage(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Mandal</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={mandal}
                                        onChange={(event) => setMandal(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>District</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={district}
                                        onChange={(event) => setDistrict(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Aadhaar</span>
                                    <input
                                        className='formInput'
                                        type="number"
                                        value={aadhaar}
                                        onChange={(event) => setAadhaar(event.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                        </div>

                        <>
                            <h2 className='formTitle'>Member 1</h2>

                            <div className='formRow'>
                                <div className='formGroup'>
                                    <span className='formLabel'>Name</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={member1.name}
                                        onChange={(event) => setMember1({ ...member1, name: event.target.value })}
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Gender</span>
                                    <select
                                        className="formInput"
                                        value={member1.gender}
                                        onChange={(event) => setMember1({ ...member1, gender: event.target.value })}
                                        style={{ width: "100%" }}
                                    >
                                        <option value="">select</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>
                            </div>

                            <div className='formRow'>
                                <div className='formGroup'>
                                    <span className='formLabel'>Age</span>
                                    <input
                                        className='formInput'
                                        type="number"
                                        value={member1.age}
                                        onChange={(event) => setMember1({ ...member1, age: event.target.value })}
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Mobile</span>
                                    <input
                                        className='formInput'
                                        type="number"
                                        value={member1.mobile}
                                        onChange={(event) => setMember1({ ...member1, mobile: event.target.value })}
                                    />
                                </div>
                            </div>

                            <h2 className='formTitle'>Member 2</h2>

                            <div className='formRow'>
                                <div className='formGroup'>
                                    <span className='formLabel'>Name</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={member2.name}
                                        onChange={(event) => setMember2({ ...member2, name: event.target.value })}
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Gender</span>
                                    <select
                                        className="formInput"
                                        value={member2.gender}
                                        onChange={(event) => setMember2({ ...member2, gender: event.target.value })}
                                        style={{ width: "100%" }}
                                    >
                                        <option value="">select</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>
                            </div>

                            <div className='formRow'>
                                <div className='formGroup'>
                                    <span className='formLabel'>Age</span>
                                    <input
                                        className='formInput'
                                        type="number"
                                        value={member2.age}
                                        onChange={(event) => setMember2({ ...member2, age: event.target.value })}
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Mobile</span>
                                    <input
                                        className='formInput'
                                        type="number"
                                        value={member2.mobile}
                                        onChange={(event) => setMember2({ ...member2, mobile: event.target.value })}
                                    />
                                </div>
                            </div>

                            <h2 className='formTitle'>Member 3</h2>

                            <div className='formRow'>
                                <div className='formGroup'>
                                    <span className='formLabel'>Name</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={member3.name}
                                        onChange={(event) => setMember3({ ...member3, name: event.target.value })}
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Gender</span>
                                    <select
                                        className="formInput"
                                        value={member3.gender}
                                        onChange={(event) => setMember3({ ...member3, gender: event.target.value })}
                                        style={{ width: "100%" }}
                                    >
                                        <option value="">select</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>
                            </div>

                            <div className='formRow'>
                                <div className='formGroup'>
                                    <span className='formLabel'>Age</span>
                                    <input
                                        className='formInput'
                                        type="number"
                                        value={member3.age}
                                        onChange={(event) => setMember3({ ...member3, age: event.target.value })}
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Mobile</span>
                                    <input
                                        className='formInput'
                                        type="number"
                                        value={member3.mobile}
                                        onChange={(event) => setMember3({ ...member3, mobile: event.target.value })}
                                    />
                                </div>
                            </div>

                            <h2 className='formTitle'>Member 4</h2>

                            <div className='formRow'>
                                <div className='formGroup'>
                                    <span className='formLabel'>Name</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={member4.name}
                                        onChange={(event) => setMember4({ ...member4, name: event.target.value })}
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Gender</span>
                                    <select
                                        className="formInput"
                                        value={member4.gender}
                                        onChange={(event) => setMember4({ ...member4, gender: event.target.value })}
                                        style={{ width: "100%" }}
                                    >
                                        <option value="">select</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>
                            </div>

                            <div className='formRow'>
                                <div className='formGroup'>
                                    <span className='formLabel'>Age</span>
                                    <input
                                        className='formInput'
                                        type="number"
                                        value={member4.age}
                                        onChange={(event) => setMember4({ ...member4, age: event.target.value })}
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Mobile</span>
                                    <input
                                        className='formInput'
                                        type="number"
                                        value={member4.mobile}
                                        onChange={(event) => setMember4({ ...member4, mobile: event.target.value })}
                                    />
                                </div>
                            </div>
                        </>

                        <button className='submitButton' type="submit" disabled={loading}>{loading ? <span className='spinner' /> : 'Register'}</button>

                    </form>
                </div>
            </div>

            <Modal
                isOpen={openPhotoUpload}
                onRequestClose={() => setOpenPhotoUpload(false)}
                style={{
                    overlay: { backgroundColor: "rgba(0,0,0,0.4)" },
                }}
                className='formContainer'
            >
                <div className='formWrapper'>
                    <h2 className='formTitle'>Holder photo upload</h2>
                    <form onSubmit={handlePhoto}>

                        <div className="formGroup">
                            <input
                                className="formInput"
                                type="file"
                                id="photo"
                                name='photo'
                            />
                        </div>
                        <div className="formRow">
                            <button
                                className='close-btn'
                                style={{ width: '95%' }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setOpenPhotoUpload(false);
                                }}>
                                <span>Close</span>
                            </button>
                            <button className="submitButton"> {loading ? <span className='spinner' /> : 'Upload'}</button>
                        </div>
                    </form>
                </div>

            </Modal >

        </>
    );
}

export default HolderRegister;